import * as english from './en.json';
import * as indonesian from './id.json';
import * as hindi from './in.json';
import * as french from './fr.json';
import * as deutsch from './de.json';

const locale = {
  en: english,
  id: indonesian,
  in: hindi,
  fr: french,
  de: deutsch,
};

export default locale;
